import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LegalLayout from './LegalLayout';
import ThemeContext from '../../context/ThemeContext';

const MentionsLegalesPage = () => {
  const { theme } = useContext(ThemeContext) || {};
  const { t } = useTranslation('legal');
  const isDark = theme === 'dark';
  const sections = t('mentions.sections', { returnObjects: true }) || [];

  const Section = ({ title, children }) => (
    <div className="mb-10 last:mb-0">
      <h2
        className={`text-xl font-bold mb-4 flex items-center gap-3 ${
          isDark ? 'text-slate-100' : 'text-slate-900'
        }`}
      >
        {title}
      </h2>
      <div
        className={`prose max-w-none ${
          isDark ? 'prose-invert text-slate-300' : 'text-slate-600'
        }`}
      >
        {children}
      </div>
    </div>
  );

  return (
    <LegalLayout title={t('mentions.title')} subtitle={t('mentions.subtitle')}>
      <div className="space-y-8">
        {sections.map((section, idx) => (
          <Section key={section.title || idx} title={section.title}>
            {section.intro && <p>{section.intro}</p>}

            {section.items && (
              <ul className="list-none mt-2 space-y-1 pl-4 border-l-2 border-indigo-500">
                {section.items.map((item) => (
                  <li key={item}>
                    {item.includes('@') ? (
                      <a
                        href={`mailto:${item.split(':').pop()?.trim() || item}`}
                        className="text-indigo-500 hover:underline"
                      >
                        {item}
                      </a>
                    ) : (
                      <span>{item}</span>
                    )}
                  </li>
                ))}
              </ul>
            )}

            {section.paragraphs &&
              section.paragraphs.map((text) => (
                <p key={text} className="mt-2 first:mt-0">
                  {text}
                </p>
              ))}

            {section.list && (
              <ul className="list-disc pl-5 mt-2 space-y-1">
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}

            {section.links?.privacy && (
              <p className="mt-2">
                <Link to="/legal/privacy" className="text-indigo-500 hover:underline">
                  {section.links.privacy}
                </Link>
              </p>
            )}

            {section.links?.cookies && (
              <p className="mt-2">
                <Link to="/legal/cookies" className="text-indigo-500 hover:underline">
                  {section.links.cookies}
                </Link>
              </p>
            )}
          </Section>
        ))}
      </div>
    </LegalLayout>
  );
};

export default MentionsLegalesPage;
